"use strict";

module.exports = {
    "ada_back": "back",
    "ada_cancel": "cancel",
    "ada_close_modal": "Close",
    "ada_escape_to_close": "Press escape to close",
    "ada_favorite": "Favorite",
    "ada_find_enter_to_select": "Press enter to select",
    "ada_find_filter_freestyle": "Coca-cola Freestyle",
    "ada_find_search": "Search",
    "ada_find_search_enter": "Press enter to search",
    "ada_find_search_text": "Enter City and State or Zipcode to find a Wendy's location",
    "ada_find_search_your_location": "Search Wendy’s restaurants near your location",
    "ada_kilometers": "Kilometers",
    "ada_limited_time_offer": "Limited Time Offer",
    "ada_miles": "Miles",
    "ada_space_to_toggle": "Press space to toggle",
    "amenities_always_open": "Open 24 Hours",
    "amenities_breakfast": "Breakfast",
    "amenities_freestyle": "Coca-Cola Freestyle©",
    "amenities_mobile_order": "Mobile Ordering",
    "amenities_mobile_pay": "Mobile Pay",
    "amenities_open_late": "Open Late",
    "amenities_wifi": "Wi-Fi",
    "common_login_and": "and",
    "common_login_cookies": "Cookies - Tracking",
    "common_login_dont_have": "Don't have an account?",
    "common_login_email_address": "Email Address",
    "common_login_email_placeholder": "Log In As",
    "common_login_email_verification_message": "Email Confirmed. Nice! Log in and find something delicious.",
    "common_login_forgot_password": "Forgot Password",
    "common_login_invalid_email": "Invalid Email",
    "common_login_login_with": "Log In with",
    "common_login_name_email_error": "The email and password do not match. Please try again.",
    "common_login_privacy_policy": "Privacy Policy",
    "common_login_read_our": "Read our",
    "common_login_required": "Required",
    "common_login_show_all": "Show All Login Options",
    "common_login_show_options": "Show All Log In Options",
    "common_login_sign_up": "Sign Up",
    "common_login_submit_button": "Submit",
    "common_login_terms_of": "Terms of Use",
    "common_login_title": "Log In",
    "common_login_welcome_back": "Welcome back",
    "common_login_with": "OR LOG IN With",
    "comp_LoginModal_ContinueAsGuest": "Continue as guest",
    "comp_LoginModal_CreateAccount_ContinueAsGuest": "Continue as guest",
    "comp_LoginModal_CreateAccount_Email_placeholder": "Email",
    "comp_LoginModal_CreateAccount_FirstName_placeholder": "First Name",
    "comp_LoginModal_CreateAccount_LastName_placeholder": "Last Name",
    "comp_LoginModal_CreateAccount_OptIn": "Sign me up for WendyMail™ so I can receive exclusive offers and insider info!",
    "comp_LoginModal_CreateAccount_Password_placeholder": "Password",
    "comp_LoginModal_CreateAccount_RegistryWith": "Or Register With",
    "comp_LoginModal_CreateAccount_SecurityQuestionAnswer_placeholder": "Security Question Answer",
    "comp_LoginModal_CreateAccount_Signup_button": "Sign Up",
    "comp_LoginModal_CreateAccount_SubText": "Enter details to create a Wendy's® Digital Account.",
    "comp_LoginModal_CreateAccount_SubText_Loyalty": "Enter details to create a Wendy's® Digital Account, then enroll in Wendy’s Rewards™.",
    "comp_LoginModal_CreateAccount_TOC": "Terms of Use",
    "comp_LoginModal_CreateAccount_TOC_first": "Read our",
    "comp_LoginModal_CreateAccount_TOS": "Terms of Service",
    "comp_LoginModal_CreateAccount_TOS_first": "I agree to the",
    "comp_LoginModal_Email_placeholder": "Enter Email",
    "comp_LoginModal_ForgotPassword": "Forgot Password?",
    "comp_LoginModal_Login_button": "Log In",
    "comp_LoginModal_OrLoginWith": "Or Login With",
    "comp_LoginModal_Password_placeholder": "Password",
    "comp_LoginModal_createAccount_button": "Create Account",
    "comp_LoginModal_forgotPassword_cancel_button": "Cancel",
    "comp_LoginModal_forgotPassword_email_address_placeholder": "Email Address",
    "comp_LoginModal_forgotPassword_first_step_description": "Enter your email in the field below and click submit.",
    "comp_LoginModal_forgotPassword_header": "Forgot Password",
    "comp_LoginModal_forgotPassword_securityQuestion_description": "Please answer the security question below and click 'Reset'.",
    "comp_LoginModal_forgotPassword_securityQuestion_done_button": "Reset",
    "comp_LoginModal_forgotPassword_securityQuestion_input_placeholder": "Security Question Answer",
    "comp_LoginModal_forgotPassword_submit_button": "Submit",
    "comp_LoginModal_header": "Login or create an account",
    "comp_LoginModal_login_button": "Login",
    "easy_as": "Easy as",
    "email_sign_up": "Sign Up",
    "email_sign_up_confirm_password": "Confirm Password",
    "email_sign_up_does_not_match": "Does Not Match",
    "email_sign_up_email_address": "Email Address",
    "email_sign_up_first_name": "First Name",
    "email_sign_up_invalid_postal": "Invalid Postal Code",
    "email_sign_up_last_name": "Last Name",
    "email_sign_up_need_info": "Enter details to create a Wendy's Digital Account.",
    "email_sign_up_need_info_loyalty": "Enter details to create a Wendy's Digital Account, then enroll in Wendy's Rewards.",
    "email_sign_up_need_postal": "Share your postal code so we can make sure you’re not missing out on something awesome.",
    "email_sign_up_page_title": "Account Sign Up",
    "email_sign_up_password": "Password",
    "email_sign_up_postal_code": "Postal Code",
    "email_sign_up_security_question": "Security Question",
    "email_sign_up_security_question_answer": "Answer to Security Question",
    "email_sign_up_select_security_question": "Select a Security Question",
    "email_sign_up_zip_desc": "This helps us give you offers and featured items exclusive to your area.",
    "email_terms_text1": "I agree to the",
    "email_verification_step1_title_1": "Check ",
    "email_verification_step1_title_2": "your email ",
    "email_verification_step1_title_3": "for a message from Wendy's.",
    "email_verification_step2_title_1": "Click ",
    "email_verification_step2_title_2": "the button ",
    "email_verification_step2_title_3": "to confirm your email address.",
    "email_verification_title": "Almost there. Just a couple more things...",
    "find_buttons_get_directions": "Get Directions",
    "find_buttons_select": "Select",
    "footer_about_us": "About Us",
    "footer_bottom_contact": "CONTACT",
    "footer_buy_cards": "",
    "footer_careers": "Careers",
    "footer_check_card_balance": "Check Card Balance",
    "footer_community": "COMMUNITY",
    "footer_contact": "Contact",
    "footer_cookie": "Cookies and Tracking",
    "footer_copyright": "© 2017 Quality Is Our Recipe, LLC",
    "footer_dave_thomas_foundation": "Dave Thomas Foundation for Adoption",
    "footer_get_app": "GET THE MY WENDY'S™ APP",
    "footer_international": "International",
    "footer_investors": "Investors",
    "footer_locations": "Locations",
    "footer_mailing_address": "5515 North Service Road, Suite 201, Burlington, Ontario, Canada L7L 6G4",
    "footer_news": "News",
    "footer_nutrition_information": "Nutrition Information",
    "footer_our_company": "OUR COMPANY",
    "footer_payment_incident": "Payment Card Incident Updates",
    "footer_privacy": "Privacy Policy",
    "footer_quick_links": "QUICK LINKS",
    "footer_responsibility": "Responsibility",
    "footer_sign_up_for_my_wendys": "",
    "footer_sitemap": "SITE MAP",
    "footer_stay_connected": "STAY CONNECTED",
    "footer_terms": "Terms of Use",
    "footer_unsubscribe": "Unsubscribe",
    "footer_wendys_gives_back": "",
    "footer_wendys_high_school_heisman": "",
    "footer_wendys_wonderful_kids": "",
    "header_about_us": "ABOUT US",
    "header_careers": "CAREERS",
    "header_feedback": "FEEDBACK",
    "header_menu_image_1": "/images/nav/en_CA/dine-men-1.png",
    "header_menu_image_2": "/images/nav/en_CA/dine-men-2.png",
    "header_menu_image_3": "/images/nav/en_CA/dine-men-3.png",
    "header_menu_image_4": "/images/nav/en_CA/dine-men-4.png",
    "header_menu_image_5": "/images/nav/en_CA/dine-men-5.png",
    "header_menu_image_6": "/images/nav/en_CA/dine-men-6.png",
    "header_menu_image_7": "/images/nav/en_CA/dine-men-7.png",
    "header_menu_image_8": "/images/nav/en_CA/dine-men-8.png",
    "header_menu_image_cta": "/images/nav/en_CA/dine-men-cta.jpeg",
    "header_menu_link_1": "https://www.wendys.com/en-ca/hamburgers",
    "header_menu_link_2": "https://www.wendys.com/en-ca/chicken",
    "header_menu_link_3": "https://www.wendys.com/en-ca/salads",
    "header_menu_link_4": "https://www.wendys.com/en-ca/right-price-right-size",
    "header_menu_link_5": "https://www.wendys.com/en-ca/fries-sides",
    "header_menu_link_6": "https://www.wendys.com/en-ca/beverages",
    "header_menu_link_7": "https://www.wendys.com/en-ca/kids-meals",
    "header_menu_link_8": "https://www.wendys.com/en-ca/frosty",
    "header_menu_link_cta": "https://www.wendys.com/en-ca/pair-2",
    "header_menu_text_1": "CHEESEBURGERS",
    "header_menu_text_2": "CHICKEN AND WRAPS",
    "header_menu_text_3": "FRESH-MADE SALADS",
    "header_menu_text_4": "EVERYDAY VALUE MENU",
    "header_menu_text_5": "FRIES & SIDES",
    "header_menu_text_6": "BEVERAGES",
    "header_menu_text_7": "WENDY'S KIDS MEAL™",
    "header_menu_text_8": "FROSTY™",
    "header_nav_learn_meal_builder_link": "https://www.wendys.com/en-ca/meal-builder",
    "header_title_main_link": "/images/common/QIOR.en_CA.png",
    "header_title_text_find": "FIND",
    "header_title_text_learn": "LEARN",
    "header_title_text_menu": "MENU",
    "header_title_text_my": "MY WENDY'S™",
    "header_title_text_order": "ORDER",
    "header_title_text_play": "PLAY",
    "language_select_canadian_english": "Canada - English",
    "language_select_canadian_french": "Canada - Français",
    "language_select_english": "US - English",
    "language_select_spanish": "US - Spanish",
    "location_page_filter_breakfast": "Breakfast",
    "location_page_filter_clear": "Clear",
    "location_page_filter_done": "Done",
    "location_page_filter_mobile_ordering": "Mobile Ordering",
    "location_page_filter_mobile_payment": "Mobile Payment",
    "location_page_filter_open_24_hours": "Open 24 Hours",
    "location_page_filter_open_late": "Open Late",
    "location_page_filter_wifi": "Wi-Fi",
    "location_page_find_location_title": "Find a Location",
    "location_page_open_today": "Open",
    "maybe_later": "Maybe Later",
    "notification_geo_failed_text": "We were unable to get your location. Please enter your location in the search box.",
    "notification_geo_failed_title": "There Was A Problem Locating You",
    "notification_modal_failure_text": "There was a problem, try again later.",
    "notification_modal_failure_title": "There was a Problem",
    "notification_modal_success_text": "We appreciate your interest in ordering online. We will let you know when this location is available to take your orders.",
    "notification_modal_success_title": "Thanks!",
    "notify_buttons_email_me": "Email Me",
    "order_buttons_order_here": "Order Here",
    "payment_options_account_created": "Account Created",
    "payment_options_add_card": "Add Card",
    "payment_options_add_funds": "Add Funds",
    "payment_options_add_new_card": "Add a New Card",
    "payment_options_are_you_sure_remove": "Are you sure you want to remove this card?",
    "payment_options_auto_reload": "Auto Reload",
    "payment_options_credit_card": "CREDIT CARD",
    "payment_options_curious_about_mobile": "Curious about mobile payment?",
    "payment_options_go_to_transaction_history": "Go To Transaction History",
    "payment_options_grab_the_app_link_text": "Grab the app!",
    "payment_options_masked_credit_card": "ending in",
    "payment_options_mobile_payment_app_explanation": "Mobile Payment is available on the My Wendy's™ app at select participating locations. Please note: your account can hold a maximum of $100.00",
    "payment_options_my_balance": "My Balance",
    "payment_options_no": "No",
    "payment_options_no_recent": "No Recent Activity",
    "payment_options_no_saved_card": "No Saved Card",
    "payment_options_payment_settings": "Payment Settings",
    "payment_options_recent_activity": "Recent Activity",
    "payment_options_remove": "Remove",
    "payment_options_remove_your_card": "Remove your card?",
    "payment_options_replace": "Replace",
    "payment_options_replace_card": "Replace your card?",
    "payment_options_replace_card_explanation_text": "Are you sure you want to replace this card? Clicking 'Yes' will remove your card from your account, even if you do not finish the process of adding a new one.",
    "payment_options_wendys_digital_account": "WENDY'S DIGITAL ACCOUNT",
    "payment_options_yes": "Yes",
    "product_tile_selected": "selected",
    "rewards_back": "Back",
    "rewards_change": "CHANGE",
    "rewards_choose": "CHOOSE",
    "rewards_choose_your_reward": "Choose Your Reward",
    "rewards_choose_your_reward_subtitle": "Earn the reward you want. You can always change it later from your Account page.",
    "rewards_done_button": "Done",
    "rewards_enrollment_disclaimer": "*Earn points and redeem rewards only on mobile orders at participating Wendy’s® restaurants.",
    "rewards_free_single": "FREE DAVE'S SINGLE",
    "rewards_join_button": "Join Rewards",
    "rewards_join_button_join": "Join",
    "rewards_join_choose_reward": "Choose Your Reward",
    "rewards_join_choose_reward_hint": "Choose what reward you want to work toward. You can change your reward at any time from your Account page.",
    "rewards_join_coming_soon_body": "Hang tight, we're still cooking up the perfect recipe for Wendy’s Rewards™. But you will be the first to know when it’s ready.",
    "rewards_join_coming_soon_title": "Rewards Are Coming Soon!",
    "rewards_join_loyalty_card_hint": "If you have a Rewards card, enter the number here so we know it’s you and we’ll add any points you’ve earned in the restaurant.",
    "rewards_join_loyalty_card_label": "Enter Your Card Number",
    "rewards_join_loyalty_card_placeholder": "Number on back of card",
    "rewards_join_loyalty_card_toggle_copy": "I was given a Rewards card at the restaurant.",
    "rewards_join_loyalty_card_toggle_hint": "Don’t have a card? Skip this step!",
    "rewards_join_loyalty_card_toggle_label": "Do You Have A Rewards Card?",
    "rewards_join_phone_hint": "Your phone number is also your Wendy’s Rewards™ number.",
    "rewards_join_phone_label": "Enter Your Phone Number",
    "rewards_join_phone_placeholder": "e.g. 123 456 7890",
    "rewards_join_postal_hint": "Wendy’s Rewards™ is only available in select markets. Find out if it has launched in your area.",
    "rewards_join_postal_label": "Enter Your Postal Code",
    "rewards_join_postal_placeholder": "e.g. 23456",
    "rewards_join_title": "Join Wendy Rewards",
    "rewards_join_value_prop": "Join Wendy Rewards and earn 1 point for every dollar spent. Simple.",
    "rewards_join_value_prop2": "Give us your phone number to complete your Rewards enrollment.",
    "rewards_join_value_prop3": "Earn 1 point for every $1 spent",
    "rewards_join_value_prop4": "on mobile orders at participating Wendy’s® restaurants",
    "rewards_join_value_prop5": "Enroll to let the points roll in.",
    "rewards_join_wendymail_body": "I want to receive WendyMail™ and be notified when Wendy’s Rewards™ is launched in my area,",
    "rewards_next_button": "Next",
    "rewards_not_now": "Not Now",
    "rewards_one": "ONE",
    "rewards_one_text": "Create an account, choose your reward, and enjoy a Dave’s Single!",
    "rewards_points": "Points",
    "rewards_points_needed": "Points Needed",
    "rewards_skip_button": "Skip Rewards",
    "rewards_step2_title": "Step 2: ",
    "rewards_terms_and_conditions": "Wendy’s Rewards™ Terms & Conditions.",
    "rewards_terms_and_conditions_preface": "By checking this box, I agree to the ",
    "rewards_three": "FREE",
    "rewards_three_text": "Enjoy free Wendy’s® when you redeem your rewards.*",
    "rewards_three_title": "Get Free Food",
    "rewards_two": "TWO",
    "rewards_two_text": "Every Wendy’s® purchase earns you points toward the rewards goal you choose.",
    "rewards_two_title": "Earn Points",
    "rewards_when_enroll": "when you enroll.",
    "rewards_yours_now": "Yours Now",
    "search_container_list": "List",
    "search_container_location_entry_placeholder": "Enter City, State, or Zipcode",
    "search_container_locations_found": "LOCATIONS FOUND",
    "search_container_map": "Map",
    "search_container_no_results_message": "No Results Found, Suggested Searches",
    "search_container_search": "Search",
    "search_result_open": "Open",
    "times_not_available": "Times not available",
    "value_proposition_caption": "Who's hungry?",
    "value_proposition_caption_img1_text_1": "Browse Wendy's",
    "value_proposition_caption_img1_text_2": "new menu items",
    "value_proposition_caption_img2_text_1": "Get the nutrition",
    "value_proposition_caption_img2_text_2": "facts you need",
    "value_proposition_caption_img3_text_1": "Sign up and save on",
    "value_proposition_caption_img3_text_2": "your favorite food",
    "value_proposition_login_text1": "Already have an account? ",
    "value_proposition_login_text2": "Log In",
    "value_proposition_sign_up_email": "Sign up with your email",
    "value_proposition_sign_up_facebook": "Sign up with Facebook",
    "value_proposition_sign_up_google": "Sign up with Google",
    "delivery_search_title": "Get It Delivered",
    "delivery_search_body": "Get all your Wendy's favorites delivered right to your door.",
    "delivery_search_button": "Go to Delivery",
    "delivery_search_loading": "LOADING"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/localization/en_CA.js
// module id = 188
// module chunks = 0